import React, { useState } from "react";
import { Facebook, Link2, Check } from "lucide-react";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" {...props}>
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.8h-.01a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.72.98 1-3.63-.24-.37a9.8 9.8 0 0 1-1.5-5.22c0-5.42 4.41-9.83 9.84-9.83 2.63 0 5.1 1.03 6.95 2.88a9.77 9.77 0 0 1 2.88 6.96c0 5.42-4.42 9.82-9.84 9.82zm8.37-18.2A11.76 11.76 0 0 0 12.04.13C5.5.13.17 5.45.17 12c0 2.09.55 4.13 1.59 5.93L.07 24l6.22-1.63a11.84 11.84 0 0 0 5.75 1.46h.01c6.54 0 11.87-5.32 11.87-11.87 0-3.17-1.24-6.15-3.5-8.4z" />
  </svg>
);

const SITE_URL = process.env.REACT_APP_SITE_URL;

export const ShareButtons = ({ slug, title, testPrefix }) => {
  const url = `${SITE_URL}/blog/${slug}`;
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      const t = document.createElement("textarea");
      t.value = url;
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      t.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const links = [
    { key: "facebook", label: "Share on Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, cls: "hover:bg-[#1877F2] hover:border-[#1877F2]" },
    { key: "whatsapp", label: "Share on WhatsApp", Icon: WhatsAppIcon, href: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`, cls: "hover:bg-[#25D366] hover:border-[#25D366]" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`${testPrefix}-share`}>
      <span className="font-cond uppercase tracking-widest text-xs text-white/50">Share this post</span>
      {links.map(({ key, label, Icon, href, cls }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testPrefix}-share-${key}`}
          className={`inline-flex items-center gap-2 border border-white/20 rounded-full px-4 py-2 font-cond uppercase tracking-widest text-xs text-white transition-colors ${cls}`}
        >
          <Icon size={16} /> {label}
        </a>
      ))}
      <button
        type="button"
        onClick={copy}
        data-testid={`${testPrefix}-share-copy`}
        aria-label="Copy link to this post"
        className={`inline-flex items-center gap-2 border rounded-full px-4 py-2 font-cond uppercase tracking-widest text-xs transition-colors ${copied ? "bg-[#E50914] border-[#E50914] text-white" : "border-white/20 text-white hover:bg-white hover:text-black hover:border-white"}`}
      >
        {copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? "Link copied!" : "Copy link"}
      </button>
    </div>
  );
};
